import { object, string, bool } from 'yup';
import HttpStatus from 'http-status-codes';

export const SchemaError = {
  [HttpStatus.BAD_REQUEST]: {
    coupon: 'Invalid coupon'
  }
};

export default object().shape({
  couponInfo: object().shape({
    coupon: string(),
    isCouponValid: bool().when('coupon', (coupon, schema) =>
      coupon ? schema.oneOf([true]) : schema
    )
  }),
  isPaymentNeeded: bool().required(),
  cardNumValid: bool().when('isPaymentNeeded', {
    is: true,
    then: bool().oneOf([true])
  }),
  cardExpValid: bool().when('isPaymentNeeded', {
    is: true,
    then: bool().oneOf([true])
  }),
  cardCVCValid: bool().when('isPaymentNeeded', {
    is: true,
    then: bool().oneOf([true])
  })
});
